import React, { useContext } from "react";
// import images
import Image1 from "../img/project/1.png";
import Image2 from "../img/project/2.png";
import Image3 from "../img/project/3.png";

// import link
import { Link } from "react-router-dom";
// import motion
import { motion } from "framer-motion";
// import transition
import { transition1 } from "../transitions";
// import context
import { CursorContext } from "../context/CursorContext";

const Projects = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <motion.section
      initial={{ opacity: 0, y: "100%" }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: "100%" }}
      transition={transition1}
      className="section"
    >
      <section></section>
      <div className="container mx-auto h-full relative">
        <div className="flex flex-col lg:flex-row h-full items-center justify-start gap-x-24 text-center lg:text-justify pt-24 lg:pt-32 pb-10">
          {/* text */}
          <motion.div
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
            initial={{ opacity: 0, y: "-80%" }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: "-80%" }}
            transition={transition1}
            className="flex flex-col lg:items-center"
          >
            <h1 className="h1">Projects</h1>
            <p className="mb-13">
              <a
                href="https://github.com/ankit-akash/shopifyecommercewebsite"
                target="_blank"
                rel="noreferrer"
              >
                <b>
                  <u>E-Commerce Website</u>
                </b>
              </a>
              <br />
              Developed using ReactJs utilizes React Styled components and its
              libraries for styling which ensures smooth navigation.
              <br />
              <br />
              <a
                href="https://github.com/ankit-akash/sales_forcast"
                target="_blank"
                rel="noreferrer"
              >
                <b>
                  <u>Sales Forcast using Linear Regression</u>
                </b>
              </a>
              <br />
              This is a robust Machine Learning project that leverages Linear
              Regression to forecast sales, utilizing Python and its libraries
              in Google Colab.
              <br />
              <br />
              <a
                href="https://github.com/ankit-akash/bankingwebsite"
                target="_blank"
                rel="noreferrer"
              >
                <b>
                  <u>Banking Website</u>
                </b>
              </a>
              <br />
              Banking website that utilizes PHP, CSS, Bootstrap, SQL, and XAMPP
              can create accounts, view account details, perform transactions,
              and view transaction history.
            </p>
            <br />
            <Link to={"/contact"} className="btn mb-[30px] mx-auto lg:mx-0">
              Contact Me
            </Link>
          </motion.div>
          {/* image grid */}
          <div
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
            className="grid grid-cols-2 lg:gap-2"
          >
            {/* image1 */}
            <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl">
              <a
                href="https://shopifyecommercewebsite.web.app/"
                target="_blank"
                rel="noreferrer"
              >
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={Image1}
                  alt="e-commerce website"
                />
                <div className="absolute -bottom-full left-8 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-white">A Frontend Website</span>
                </div>
                <div className="absolute -bottom-full left-8 group-hover:bottom-14 transition-all duration-700 z-50">
                  <span className="text-2xl text-white">
                    E-Commerce Website
                  </span>
                </div>
              </a>
            </div>
            {/*image2*/}
            <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl">
              <a
                href="https://github.com/ankit-akash/sales_forcast"
                target="_blank"
                rel="noreferrer"
              >
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={Image2}
                  alt="Machine Learning"
                />
                <div className="absolute -bottom-full left-8 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-white">Machine Learning</span>
                </div>
                <div className="absolute -bottom-full left-8 group-hover:bottom-14 transition-all duration-700 z-50">
                  <span className="text-2xl text-white">Sales Forcast</span>
                </div>
              </a>
            </div>

            {/*image3*/}
            <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl">
              <a
                href="https://swiss-foundation.000webhostapp.com/"
                target="_blank"
                rel="noreferrer"
              >
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={Image3}
                  alt="Fullstack website"
                />
                <div className="absolute -bottom-full left-8 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-white">A FullStack Website</span>
                </div>
                <div className="absolute -bottom-full left-8 group-hover:bottom-14 transition-all duration-700 z-50">
                  <span className="text-2xl text-white">
                    Basic Banking Website
                  </span>
                </div>
              </a>
            </div>

            {/*image4*/}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Projects;
